import React, { memo } from 'react'
import injectSheet from 'react-jss'
import { entryStyle, skeletonStyle } from './skeleton.styles'
import Bone from 'pobble-components/dist/bone'
import { Cell, TableRow } from 'pobble-components/dist/table'
import { useMe } from 'pobble-components/dist/pobble-user'

const Entry = injectSheet(entryStyle)(
  ({ classes, titleWidth, canSeePupils }) => (
    <TableRow>
      <Cell center>
        <Bone className={classes.checkbox} />
      </Cell>
      <Cell>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div
            className={classes.thumbnail}
            style={{ width: '160px', marginRight: '16px' }}>
            <Bone
              style={{
                paddingBottom: '56.25%',
                height: '0',
                borderRadius: '4px'
              }}
            />
          </div>
          <div>
            <Bone style={{ height: '8px', width: '60px', display: 'block' }} />
            <Bone style={{ height: '12px', width: '120px' }} />
          </div>
        </div>
      </Cell>
      <Cell>
        <Bone style={{ height: '12px', width: '80px' }} />
      </Cell>
      <Cell right>
        <div className={classes.actions}>
          <Bone className={classes.action} />
        </div>
      </Cell>
    </TableRow>
  )
)

const Skeleton = injectSheet(skeletonStyle)(
  memo(({ classes }) => {
    const { me } = useMe()
    const canSeePupils = !!me.account.teacher_type
    return (
      <tbody className={classes.container}>
        {[...Array(10).keys()].map((_, index) => (
          <Entry
            key={index}
            canSeePupils={canSeePupils}
            titleWidth={Math.floor(Math.random() * (100 - 70)) + 70}
          />
        ))}
      </tbody>
    )
  })
)

export default injectSheet(skeletonStyle)(Skeleton)
